import {useMemo} from "react";
import {useTranslation} from "react-i18next";

import Button from "../../ui/button";
import DropdownList from "../../ui/dropdownlist";
import {CaretDown} from "../../ui/icons";

import {useAsyncDownloadWithToast} from "../../hooks/useAsyncDownloadWithToast";

export interface ReportItem {
  url: string;
  filename: string;
  title: string;
}

export interface EducationReportsProps {
  reports: ReportItem[];
  disabledAll?: boolean;
  buttonClassName?: string;
  dropdownClassName?: string;
}

export default function EducationReports({
  reports,
  disabledAll,
  buttonClassName,
  dropdownClassName,
}: EducationReportsProps) {
  const {t} = useTranslation();

  const {handleAsyncExport} = useAsyncDownloadWithToast();

  const dropdownCSVMenu = useMemo(
    () =>
      reports.map((report) => (
        <DropdownList.Action
          key={report.url}
          as="a"
          onClick={() => handleAsyncExport(report.url || "", report.filename)}
          title={report.title}
        />
      )),
    [reports, handleAsyncExport],
  );

  return (
    <DropdownList
      rounded
      dropShadow
      placement="bottom-end"
      offset={[0, 8]}
      className={dropdownClassName}
      content={dropdownCSVMenu}
    >
      <Button className={buttonClassName} disabled={disabledAll}>
        {t("members.reports.title")}
        <CaretDown />
      </Button>
    </DropdownList>
  );
}
